import { getUrl } from "aws-amplify/storage";
import React, { useEffect, useState } from "react";

export default ({ imgKey, style }) => {
    const [uri, setUri] = useState(null);
    useEffect(() => {
        const getUri = async (k) => {
            const resp = await getUrl({ path: `public/${k}` });
            setUri(resp.url);
        };

        if (imgKey) {
            getUri(imgKey);
        }
    }, [imgKey]);

    if (!uri) {
        return <></>;
    }
    return <img src={uri} style={style} />;
};
